import { render, staticRenderFns } from "./PublicKeys.vue?vue&type=template&id=4534e609&"
import script from "./PublicKeys.vue?vue&type=script&lang=js&"
export * from "./PublicKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports